import { render, staticRenderFns } from "./NotaDeEntrega.vue?vue&type=template&id=240a84fe&scoped=true"
import script from "./NotaDeEntrega.vue?vue&type=script&lang=js"
export * from "./NotaDeEntrega.vue?vue&type=script&lang=js"
import style0 from "./NotaDeEntrega.vue?vue&type=style&index=0&id=240a84fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240a84fe",
  null
  
)

export default component.exports